import React from 'react';
import LandingWrapper from '@/components/Landing/LandingWrapper/LandingWrapper';
import ResetPasswordForm from '@/components/Landing/Forms/ResetPasswordForm/ResetPasswordForm';

const ResetPassword = () => {
  return <LandingWrapper Form={ResetPasswordForm} />;
};

export default ResetPassword;
